/**
 * `kind:id` ↔ `{ kind, id }` for the `?item=` param of the profile slide-out.
 * The id may itself contain a colon; only the first one separates.
 */
export const parseItemParam = (value) => {
  if (typeof value !== 'string') return null;
  const separator = value.indexOf(':');
  if (separator <= 0 || separator === value.length - 1) return null;
  return { kind: value.slice(0, separator), id: value.slice(separator + 1) };
};

export const formatItemParam = (kind, id) => `${kind}:${id}`;
